<app-header></app-header>

<app-filter (filterChanged)="onFilterChanged($event)"></app-filter>

<section class="cards" *ngFor="let country of filteredCountries | slice:0:8">
  <app-country-card [country]="country"></app-country-card>
</section>
